export default __webpack_public_path__ + "static/media/2.ff3ff8ad.jpg";